import { makeAutoObservable } from "mobx"
import { TChain, TType } from "../types";

class PlotMenuStore {
    private _defaultType: Array<TType> | undefined | null
    private _defaultChains: Array<string> | undefined | null
    private _defaultCoin: string | undefined | null
    private _defaultExchange: string | undefined | null

    
    constructor() {
        makeAutoObservable(this)
    }

    get defaultType() {
        return this._defaultType
    }

    get defaultChains() {
      return this._defaultChains
    }

    get defaultCoin() {
      return this._defaultCoin
    }

    get defaultExchange() {
      return this._defaultExchange
    }


    loadDefaultOptions(query: string) {
        query = query.slice(1)
        const dict: Record<string, string | TType> = {}

        const pairs = query.split('&')
        for (const pair of pairs) {
            const [key, value] = pair.split('=')
            dict[key] = value
        }

        this._defaultType = dict.type?.split(',') as TType[] || ["long", "short"]
        this._defaultChains = dict.chains?.split(',') as string[] || null
        this._defaultCoin = dict.coin || null
        this._defaultExchange = dict.exchange || null
    }
}

export default new PlotMenuStore()